module.exports = __webpack_public_path__ + "img/black45.8a93e934.png";